export default __webpack_public_path__ + "static/media/phanbot-animated.158a787f.webm";